// extracted by mini-css-extract-plugin
module.exports = {"notifications":"NotificationsPage_notifications__1BvNf","name":"NotificationsPage_name__1UZpi","email":"NotificationsPage_email__24_BZ","writer":"NotificationsPage_writer__1c1fE"};